import { onMounted, onBeforeUnmount } from '@nuxtjs/composition-api';

export function useArrowNavigation(nextSlide, previousSlide) {
  const handleKeydown = (e) => {
    if (e.key === 'ArrowRight') {
      // Arrow scrolling
      e.preventDefault();
      nextSlide();
    } else if (e.key === 'ArrowLeft') {
      // Arrow scrolling
      e.preventDefault();
      previousSlide();
    }
  };
  onMounted(() => {
    window.addEventListener('keydown', handleKeydown);
  });
  onBeforeUnmount(() => {
    window.removeEventListener('keydown', handleKeydown);
  });
}
